import { toast } from 'sonner'

export async function copyTextToClipboard(value: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value)
    return
  }

  const textArea = document.createElement('textarea')
  textArea.value = value
  textArea.setAttribute('readonly', '')
  textArea.style.position = 'fixed'
  textArea.style.left = '-9999px'
  textArea.style.top = '0'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const copied = document.execCommand('copy')
    if (!copied) {
      throw new Error('Copy command failed')
    }
  } finally {
    document.body.removeChild(textArea)
  }
}

export async function copyCredentialPassword(password?: string | null): Promise<void> {
  const value = String(password ?? '').trim()
  if (!value) {
    toast.error('Password is unavailable to copy')
    return
  }

  try {
    await copyTextToClipboard(value)
    toast.success('Password copied')
  } catch {
    toast.error('Failed to copy password')
  }
}